import useResize from '../../../../../hooks/useResize'
import { VIEWPORT_LG } from '../../../../../utils/constants'
import { TAB_BAR_UPLOAD_VIDEO_TALENTS_OPTIONS } from '../../../constants'
import { useTabBarUploadVideoTalentStore } from '../../globalStore'
import TabBarUploadVideoTalent from '../../smallComponents/TabBarUploadVideoTalent/TabBarUploadVideoTalent'
import Delivery from './Options/Delivery'
import Example from './Options/Example'
import Instructions from './Options/Instructions'

const Challenge = ({userData}) => {
  const { tabBarValue, setTabBarValue } = useTabBarUploadVideoTalentStore()
   const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG

  const renderTabBarOptions = {
    [TAB_BAR_UPLOAD_VIDEO_TALENTS_OPTIONS.instructions]: <Instructions userData={userData}/>,
    [TAB_BAR_UPLOAD_VIDEO_TALENTS_OPTIONS.example]: <Example />,
    [TAB_BAR_UPLOAD_VIDEO_TALENTS_OPTIONS.delivery]: <Delivery />,
  }

  return (
    <div className="d-flex flex-column align-items-center">
      <h1 className={`${isMobile ? 'fontSize24' : 'fontSize40'} text-on-bg-primary  fw-bold text-center`}>
        Reto de Hutrit Club
      </h1>
      <h2 className={`${isMobile ? 'fontSize14' : 'fontSize24'} text-on-bg-primary pt-3 text-center`}>
        Si has llegado hasta aquí, es porque tienes algo especial. Pero ahora
        viene lo <br /> importante: <strong>demostrarlo</strong>.
      </h2>
      <TabBarUploadVideoTalent
        tabBarValue={tabBarValue}
        setTabBarValue={setTabBarValue}
      />
      {renderTabBarOptions[tabBarValue]}
    </div>
  )
}

export default Challenge
